export default __webpack_public_path__ + "static/media/logo-nahartime.234a0680.svg";